<!-- Header  -->
<div class="d-flex popup-head align-items-center">
  <div class="popup-title mr-auto" translate>lblCallDetails</div>
  <div class="float-right">
    <a class="close mr-2" (click)="OnClose()" translate>
      <span aria-hidden="true">&times;</span>
    </a>
  </div>
</div>
<div class="subheader with-padding flgrow">
  <div class="row align-items-center">
    <div class="col-lg-6 col-md-6 col-sm-6">
      <div class="input-group">
        <input
        class="form-control"
        type="text"
        [(ngModel)]="dealerName"
        disabled
      />
      </div>
    </div>
    <div class="col-lg-3 col-md-3 col-sm-6">
      <div class="date">
        <input
          class="form-control"
          type="text"
          [(ngModel)]="selectedDate"
          disabled
        />
      </div>
    </div>


    <!-- Clear Button -->
      <a
        class="ml-2 btn btn-outline-primary"
        href="javascript:void(0);"
        (click)="onRefresh()"
        aria-label="Center Align"
      >
      <em class="fas fa-sync fa-lg"></em>
    </a>
    <div class="pl-2  align-items-center flex-sm-row flex-column justify-content-end ml-auto" >
    <!-- Excel -->
    <button type="button" (click)="exportAsXLSX()" ngbTooltip="{{ 'lblExportExcel' | translate }}" placement="bottom"
      aria-label="Center Align" style="margin-right: 10px; margin-top: 1.1rem;">
      <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
    </button>
    <!-- PDF -->
    <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()" style="margin-top: -0.4rem;"
      ngbTooltip="{{ 'lblExportPDF' | translate }}" placement="bottom" aria-label="Center Align">
      <em class="far fa-file fa-2x"></em>
      <span class="bdg">PDF</span>
    </button>
    </div>
  </div>
</div>

<!-- Body -->
<div class="scrollbar user">
  <div class="row">
    <div class="c12">
      <div class="card">
        <!-- Body Header -->
        <div class="card-header d-flex justify-content-between mx-2" translate>
          lblCallDetails
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
            {{ totalCount }}
            &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>

        <!-- Body Content -->
        <div class="table-responsive max-h357" infinite-scroll [infiniteScrollDistance]="scrollDistance"
        [infiniteScrollThrottle]="throttle" [alwaysCallback]="true" [scrollWindow]="false" (scrolled)="loadMoreData($event)">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th scope="col" translate>lblRegNumber</th>
                <th scope="col" translate>lblWoNo</th>
                <th scope="col" translate>lblCustomer</th>
                <th scope="col" translate>lblDealerName</th>
                <th scope="col" translate>lblCallDate</th>
              </tr>
            </thead>

            <tbody>
              <ng-container
                *ngIf="
                callDealerLogsList?.length > 0;
                  else load_NotFound_Template
                "
              >
                <tr *ngFor="let item of callDealerLogsList; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>
                    <div class="flmid">
                      <div class="licplate LPNo d-flex">
                        <span
                          class="icn-flag"
                          [ngClass]="licensePlateClass"
                        ></span>
                        {{ item.licensePlate }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.workOrderNo">
                    </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.customerName"> </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.dealerName">
                    </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.callDateTime | date : 'short'">
                    </ngb-highlight>
                  </td>
                </tr>
              </ng-container>

              <ng-template #load_NotFound_Template>
                <tr>
                  <td colspan="8" class="no-record" translate>
                    lblNoRecordsFound
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Footer -->
<div class="p-3 bg-light pp-footer-top-brdr">
  <div class="row">
    <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
      <a
        (click)="OnClose()"
        type="reset"
        class="btn btn-secondary btn-lg"
        translate
        ><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a
      >
    </div>
  </div>
</div>
